import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, useIsParentOrAdmin } from '@/hooks/useAuth';
import { AuthPage, DashboardPage, CalendarTab, FamilyTab, GuardianDashboardTab, CareTab, SettingsPage, KaiScheduleTab } from '@/pages';
import { TaskList } from '@/components/tasks/TaskList';

// Protected route wrapper for parent/admin only routes
function ParentOrAdminRoute({ children }: { children: React.ReactNode }) {
  const isParentOrAdmin = useIsParentOrAdmin();
  const { isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!isParentOrAdmin) {
    return <Navigate to="/dashboard/calendar" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      {/* Auth page */}
      <Route path="/" element={<AuthPage />} />

      {/* Dashboard with tabs */}
      <Route path="/dashboard" element={<DashboardPage />}>
        <Route index element={<Navigate to="calendar" replace />} />
        <Route path="calendar" element={<CalendarTab />} />
        <Route path="family" element={<FamilyTab />} />
        <Route path="care" element={<CareTab />} />
        <Route path="schedule" element={<KaiScheduleTab />} />
        <Route path="tasks" element={<TaskList />} />
        <Route
          path="overview"
          element={
            <ParentOrAdminRoute>
              <GuardianDashboardTab />
            </ParentOrAdminRoute>
          }
        />
      </Route>

      {/* Settings page */}
      <Route path="/settings" element={<SettingsPage />} />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
